module.exports = __webpack_public_path__ + "static/media/technical_issues.3598179a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/techincal_issues/technical_issues.svg
// module id = 1579
// module chunks = 1